module.exports = {
  title: 'Exclusion Tabs with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-08-27',
  slug: 'exclusion-tabs',
  tags: ['skia', 'reanimated'],
};
